





















import { Vue, Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import * as api from "../api";
import { tree, cc } from "../utils";
import FormRows from "../parts/FormRows";
import { InputRow } from "../models";
import App from '../App'
import { shuffle, sleep, normalizeModel, bakeRemoteData } from '../utils'
import SelectNode from '../parts/SelectNode'
import { remoteOp } from "../helper";

interface UnsetState {
  kind: 'unset';
}

interface ErrorState {
  kind: 'error';
  message: string;
}

interface DoneState {
  kind: 'done';
  model: {[k: string]: any};
  fields: {name: string, label: string}[];
}

type State = UnsetState | ErrorState | DoneState

@Component({
  components: { FormRows },
})
export default class UniFormView extends Vue {

  id = 0  

  state: State = {kind: 'unset'}

  loading = false

  get status() {
    return this.state.kind
  }

  created() {
    this.reset()
  }

  @Watch('$route')
  $routeChanged() {
    if (this.$route.name === 'uniForm-view') {
      this.reset()
    }
  }

  private async reset() {
    this.id = parseInt(this.$route.params.id)
    this.loading = true
    try {
      let result = await api.invoke('uniForm/get', this.id)
      this.state = {
        kind: 'done',
        model: result.data,
        fields: result.fields,
      }
      this.loading = false
    }
    catch (e) {
      this.loading = false
      this.state = {kind: 'error', message: (e as Error).message}
    }
  }

  close() {
    this.$router.replace({ name: 'uniForm-list' })
  }
}
